import React from 'react'

interface SwitchProps {
	checked?: boolean
	disabled?: boolean
	checkedLabel?: React.ReactNode
	uncheckedLabel?: React.ReactNode
	className?: string
	onChange?: (checked: boolean) => void
	onFocus?: React.FocusEventHandler<HTMLButtonElement>
	onBlur?: React.FocusEventHandler<HTMLButtonElement>
	onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>
	autoFocus?: boolean
}

const Switch: React.FC<SwitchProps> = ({
	checked = false,
	disabled = false,
	checkedLabel = 'Open',
	uncheckedLabel = 'Close',
	className = '',
	onChange,
	onFocus,
	onBlur,
	onKeyDown,
	autoFocus,
}) => {
	const handleClick = () => {
		if (!disabled) onChange?.(!checked)
	}

	return (
		<button
			type="button"
			role="switch"
			aria-checked={checked}
			disabled={disabled}
			autoFocus={autoFocus}
			onClick={handleClick}
			onFocus={onFocus}
			onBlur={onBlur}
			onKeyDown={onKeyDown}
			className={`
				relative grid h-[44px] min-w-[150px] grid-cols-2 items-center overflow-hidden rounded-md border text-text-md shadow-xs outline-none transition-all
				${disabled ? 'cursor-default border-gray-300 bg-gray-50 text-gray-300' : 'border-gray-300 bg-white text-gray-500 hover:border-primary-500 focus:border-primary-500 focus:shadow-focus'}
				${className}
			`}
		>
			<span
				className={`
					absolute inset-y-[3px] w-[calc(50%-3px)] rounded transition-all
					${checked ? 'left-[calc(50%)] bg-primary-500' : 'left-[3px] bg-primary-500'}
					${disabled ? '!bg-gray-300' : ''}
				`}
			/>
			<span className={`relative z-[1] px-md transition-all ${!checked ? 'text-white text-shadow-sm' : ''}`}>
				{uncheckedLabel}
			</span>
			<span className={`relative z-[1] px-md transition-all ${checked ? 'text-white text-shadow-sm' : ''}`}>
				{checkedLabel}
			</span>
		</button>
	)
}

export default Switch
